export default {"src":"https://fishbrain.com/_next/static/media/minnesota.28ae4da8.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};